import React from 'react';
import { STORAGE_KEY } from './use-tracking-flusher';
import { getFromLocalStorage } from '../../../utils/get-from-local-storage';
import { LogRequest, MeUser } from '../../../@api-client';

export interface UseTrackingOptions {
  trackingEnabled?: boolean;
  trackingData?: TrackingData;
  eventType?: string;
  eventName?: string;
  eventMetadata?: Record<string, unknown>;
  ariaLabel?: string;
  children?: React.ReactNode;
}

export type TrackingData = {
  user?: MeUser;
  origin?: string;
  type?: string;
  level?: 'log' | 'info' | 'warn' | 'error' | 'debug';
  name?: string;
  description?: string;
  metadata?: Record<string, any>;
};

export function useTracking(options: UseTrackingOptions) {
  const trackEvent = (element: string, eventType?: string, eventName?: string) => {
    const meta = {
      eventName:
        options.trackingData?.name || (eventName ?? (options.ariaLabel || 'Unnamed Element')),
      origin: options.trackingData?.origin || window.location.href,
      ...options.trackingData?.metadata,
      ...options.eventMetadata,
      component: element,
    };

    const trackBody: LogRequest = {
      type: options.trackingData?.type || eventType || 'audit',
      level: options.trackingData?.level || 'info',
      args: ['audit event'],
      timestamp: new Date().toISOString(),
      clientInfo: {
        userAgent: navigator.userAgent,
      },
      meta,
    };

    const existingEvents = getFromLocalStorage<LogRequest[]>(STORAGE_KEY, []);
    existingEvents.push(trackBody);
    localStorage.setItem('trackingEvents', JSON.stringify(existingEvents));

    window.dispatchEvent(new CustomEvent('tracking:updated', { detail: 'trackingEvents' }));
  };

  return { trackEvent };
}
